<nz-layout class="h-[100vh] bg-black">
  <nz-sider nzTheme="light" nzCollapsible [(nzCollapsed)]="isCollapsed" [nzTrigger]="null" nzWidth="285px"
    class="bg-white border-r">
    <div class="h-[66px] flex items-center pl-[13px]">
      <a class="flex items-center font-medium text-gray-900 title-font md:mb-0" routerLink="/" nz-tooltip
        nzTooltipPlacement="right" nzTooltipTitle="Home">
        <img *ngIf="!isCollapsed" [src]="'assets/images/son_logo.png'"
          class="w-[50px] rounded-full overflow-hidden object-fill" />
        <img *ngIf="isCollapsed" [src]="'assets/images/son_logo.png'"
          class="w-[50px] rounded-full overflow-hidden object-fill" />
      </a>
    </div>
    <app-admin-sidemenu [isCollapsed]="isCollapsed" slug="super-admin"></app-admin-sidemenu>
  </nz-sider>

  <nz-layout class="bg-white">
    <nz-header class="border-b h-[66px] px-[40px]">
      <app-admin-header slug="super-admin"></app-admin-header>
    </nz-header>

    <nz-content class="p-10 overflow-y-auto">
      <router-outlet></router-outlet>
    </nz-content>
  </nz-layout>
</nz-layout>